import { positionsMiddleware } from './positions-middleware';

export const positionsMiddlewares = [positionsMiddleware];
